module.exports = __webpack_public_path__ + "img/5.cce52d81.png";